const menuBtnEl = document.querySelector("header .menu-btn")
const modalMenuEl = document.querySelector("header .menu-modal")

menuBtnEl.addEventListener("click", () => {
    if (modalMenuEl.dataset.hidden === "true") {
        modalMenuEl.dataset.hidden = false;
    } else {
        modalMenuEl.dataset.hidden = true;
    }
})